export default __webpack_public_path__ + "locales/lv/Webhooks.json?hash=dc5c462f16af4d815aeaf22def896d31";